/* eslint-disable @next/next/no-img-element */
import SelectableBoxWithOutline from 'components/common/Box/SelectableBoxWithOutline';
import { MainDrawDay } from 'constants/Draw';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import DrawDaysPopup from '../DrawDaysPopup';
import { BoxWithOptionalNumberedHeading } from './BoxWithNumberedHeading';

export const ChooseDrawDays = observer(() => {
  const { dayEnabled, setDays } = useEnterStore();

  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const buttonSize = 70;

  return (
    <BoxWithOptionalNumberedHeading
      additionalClassName={'!border-2'}
      number={undefined}
      onClickInfoIcon={() => setShowInfoPopup(true)}
    >
      {showInfoPopup && (
        <DrawDaysPopup onClose={() => setShowInfoPopup(false)} />
      )}
      <p
        style={{ fontSize: 20 }}
        className="mb-0 normal-case spacing-normal tracking-normal font-extrabold text-center w-full "
      >
        Draw Days
        <img
          src={`${ASSET_PREFIX}/images/info-circle.svg`}
          className="hover:pointer-cursor h-5 ml-2 pt-1"
          onClick={() => setShowInfoPopup(true)}
          alt="more info"
        />
      </p>
      <div className="chooseDraws flex fullWidth !space-between px-0">
        <SelectableBoxWithOutline
          additionalClassName="w-full !h-16 "
          selected={dayEnabled.TUESDAY}
          onClick={() => {
            if (dayEnabled.TUESDAY) {
              setDays([MainDrawDay.FRIDAY]);
            } else {
              setDays([MainDrawDay.TUESDAY, MainDrawDay.FRIDAY]);
            }
          }}
          centerVertical
          centerHorizontal
          styles={{ height: buttonSize }}
        >
          <p className="medium bold">Tuesday</p>
        </SelectableBoxWithOutline>

        <SelectableBoxWithOutline
          styles={{ height: buttonSize }}
          additionalClassName="w-full !h-16"
          selected={dayEnabled.FRIDAY}
          onClick={() => {
            if (dayEnabled.FRIDAY) {
              setDays([MainDrawDay.TUESDAY]);
            } else {
              setDays([MainDrawDay.TUESDAY, MainDrawDay.FRIDAY]);
            }
          }}
          centerVertical
          centerHorizontal
        >
          <p className="medium bold">Friday</p>
        </SelectableBoxWithOutline>
      </div>

      <style jsx>
        {`
          .chooseDraws {
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 0.75em;
          }
          .drawOption {
            padding: 1.5em 1em;
            text-align: center;
          }
        `}
      </style>
    </BoxWithOptionalNumberedHeading>
  );
});
